import Line from './LineWidget'
const charts = {
    Line
}

export default charts